import React, { useState } from 'react';
import UserTable from '../components/users/UserTable';
import { mockUsers, userGrowthData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import { Users as UsersIcon, UserPlus, UserMinus, UserCheck } from 'lucide-react';
const Users: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState('all');
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const handleViewProfile = (userId: string) => {
    setSelectedUser(userId);
    // In a real implementation, you might navigate to a user profile page
    console.log(`Viewing user profile: ${userId}`);
  };
  return <div className="space-y-6" data-id="element-1828">
      <div data-id="element-1829">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1830">
          User Management
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1831">
          Manage users, view profiles, and monitor user activity.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1832">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1833">
          <div className="flex items-center" data-id="element-1834">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1835">
              <UsersIcon size={24} data-id="element-1836" />
            </div>
            <div className="ml-5" data-id="element-1837">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1838">
                Total Users
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1839">
                12,543
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1840">
          <div className="flex items-center" data-id="element-1841">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-1842">
              <UserCheck size={24} data-id="element-1843" />
            </div>
            <div className="ml-5" data-id="element-1844">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1845">
                Active Users
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1846">
                8,721
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1847">
          <div className="flex items-center" data-id="element-1848">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-200" data-id="element-1849">
              <UserPlus size={24} data-id="element-1850" />
            </div>
            <div className="ml-5" data-id="element-1851">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1852">
                New This Month
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1853">
                1,245
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1854">
          <div className="flex items-center" data-id="element-1855">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-200" data-id="element-1856">
              <UserMinus size={24} data-id="element-1857" />
            </div>
            <div className="ml-5" data-id="element-1858">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1859">
                Churned Users
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1860">
                87
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-1861">
        <ChartCard title="User Growth Trend" subtitle="New user registrations over time" data={userGrowthData} type="line" dataKeys={['users']} colors={['#3B82F6']} data-id="element-1862" />
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1863">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-1864">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1865">
            User List
          </h3>
        </div>
        <div className="p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-1866">
          <div className="flex space-x-2" data-id="element-1867">
            <button onClick={() => setSelectedTab('all')} className={`px-4 py-2 text-sm font-medium rounded-md ${selectedTab === 'all' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'}`} data-id="element-1868">
              All Users
            </button>
            <button onClick={() => setSelectedTab('active')} className={`px-4 py-2 text-sm font-medium rounded-md ${selectedTab === 'active' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'}`} data-id="element-1869">
              Active
            </button>
            <button onClick={() => setSelectedTab('inactive')} className={`px-4 py-2 text-sm font-medium rounded-md ${selectedTab === 'inactive' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'}`} data-id="element-1870">
              Inactive
            </button>
            <button onClick={() => setSelectedTab('pending')} className={`px-4 py-2 text-sm font-medium rounded-md ${selectedTab === 'pending' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'}`} data-id="element-1871">
              Pending
            </button>
          </div>
        </div>
        <UserTable users={selectedTab === 'all' ? mockUsers : mockUsers.filter(user => user.status === selectedTab)} onViewProfile={handleViewProfile} data-id="element-1872" />
      </div>
    </div>;
};
export default Users;